import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { EApplicantBehaviourEventType, EDecisionType, EDetectionType, EFaceDetectionStatus, EQuestionContentURLType, QuestionCollectionCategoryEnum, QuestionExpectedAnswerType } from '@app/shared/common/enums';
import { MultipleChoiceAnswerItem } from '@app/vinter/models/answer/multiple-choice-answer-item';
import { ApplicantRecordItem, ApplicantRecordLogItem } from '@app/vinter/models/applicant-record-item';
import { QuestionListItem } from '@app/vinter/models/question-list-item';
import { ApplicantRecordService } from '@app/vinter/services/ApplicantRecord.service';
import { ApplicantBehaviourEventLogService } from '@app/vinter/services/applicant-behaviour-event-log.service';
import { ApplicantRecordLogService } from '@app/vinter/services/applicant-record-log.service';
import { ApplicantDetailBehaviorCommunicationService } from '@app/vinter/services/applicant-detail-behavior-analysis-communation.service';
@Component({
  selector: 'app-multiple-choice-answer',
  templateUrl: './multiple-choice-answer.component.html',
  styleUrls: ['./multiple-choice-answer.component.scss']
})
export class MultipleChoiceAnswerComponent implements OnInit {

  @Input() answer: MultipleChoiceAnswerItem;
  @Input() question: QuestionListItem;
  @Input() questionId: string;
  @Input() ApplicationStepId: string;
  @Output() updateSuspicionOfCheating: EventEmitter<ApplicantRecordLogItem> = new EventEmitter<ApplicantRecordLogItem>();

  QuestionExpectedAnswerType = QuestionExpectedAnswerType;
  QuestionContentType = EQuestionContentURLType;
  questionCollectionCategories = QuestionCollectionCategoryEnum;
  selectedAnswerChoice: any
  selectedRadioValue: any;
  questionPageHiddenLog: number;
  EFaceDetectionStatus = EFaceDetectionStatus;
  showDetails = false;
  CheatingPicturesUrls: any = "";
  isFaceDivVisible = true;
  isMultiFaceDivVisible = true;
  isNonFaceDivVisible = true;
  decisionTypeEnum = EDecisionType;
  detectionTypeEnum = EDetectionType;

  constructor( private eventLogService: ApplicantBehaviourEventLogService,
    private applicantRecordLogService : ApplicantRecordLogService,
    private applicantRecordService : ApplicantRecordService,
    private applicantDetailBehaviorCommunicationService : ApplicantDetailBehaviorCommunicationService
  ){}

  ngOnChanges(changes: SimpleChanges): void {
    if(this.question){
      var selectedAnswerIndex = this.question.choiceContents.findIndex(x => x.id == this.answer?.choiceAnswer?.choiceContentId);
      this.selectedAnswerChoice = this.question.choiceContents[selectedAnswerIndex];
      this.CheatingPicturesUrls  = "";
      this.showDetails = false;
    }
    if(this.answer){
      this.showDetails = false
      this.CheatingPicturesUrls  = "";
      this.getPageHiddenLog();
    }
  }

  ngOnInit(): void {
    if(this.question){
      var selectedAnswerIndex = this.question.choiceContents.findIndex(x => x.id == this.answer?.choiceAnswer?.choiceContentId);
      this.selectedAnswerChoice = this.question.choiceContents[selectedAnswerIndex];
    }
    if(this.answer){
      this.getPageHiddenLog();
    }
  }

isCorrectAnswer(choiceContentId: string): boolean {
  const correctChoice = this.question?.choiceContents?.find(choice => choice.id === this.answer?.choiceAnswer?.choiceContentId);
  this.selectedRadioValue = correctChoice ? correctChoice.choiceText : null;
  return this.answer?.choiceAnswer && this.answer?.choiceAnswer?.choiceContentId === choiceContentId && this.answer?.choiceAnswer?.isCorrect;
}

isWrongAnswer(choiceContentId: string): boolean {
  return this.answer?.choiceAnswer && this.answer?.choiceAnswer?.choiceContentId === choiceContentId && !this.answer?.choiceAnswer?.isCorrect;

}

checkAnswer(choiceContentId: string): boolean {
    let result = false;
    if (choiceContentId === null || choiceContentId === undefined) {
        result = false;
    }
    else {
        if (this.answer?.choiceAnswer?.choiceContentId === choiceContentId && this.answer?.choiceAnswer?.isCorrect) {
            result = true;
        }
        else {
            result = false;
        }
    }
    return result
}

getPageHiddenLog(){
  let eventLogFilter: any = {};
  eventLogFilter.applicationStepId = this.answer.applicationStepId;
  eventLogFilter.eventType = EApplicantBehaviourEventType.PageHidden;
  eventLogFilter.questionId = this.answer.questionId;
  this.eventLogService.getListByFilter(eventLogFilter).subscribe(eventLog => {
      this.questionPageHiddenLog = eventLog.length;
  });
}
getApplicantRecord()
{
  if (this.answer?.isFaceDetected ||
    this.answer?.isMultiFaceDetected ||
    this.answer?.faceDetectionStatus === EFaceDetectionStatus.UnverifiedAndNonFace ||
    this.answer?.faceDetectionStatus === EFaceDetectionStatus.VerifiedAndNonFace
  ) {
    const recordItem: ApplicantRecordItem = {
      questionId: this.questionId,
      applicationStepId: this.ApplicationStepId,
      filePathUrl: null
    };
  
    this.applicantRecordService
      .ListImagesInApplicantFolderAsync(recordItem)
      .subscribe({
        next: (result) => {
          if (result) {
            this.CheatingPicturesUrls = result;
          } else {
            console.error(result);
          }
        },
        error: (err) => console.error(err)
      });
  }
}
toggleDetails() {
  this.showDetails = !this.showDetails;
  if (this.showDetails && this.CheatingPicturesUrls?.length === 0) {
    this.getApplicantRecord();
  }
}
  hideWarningAndSaveLog(detType: EDetectionType, decType: EDecisionType) {
    const LogItem: ApplicantRecordLogItem = {
      questionId: this.questionId,
      applicationStepId: this.ApplicationStepId,
      decisionType :decType,
      detectionType : detType, 
    };
    
    this.applicantRecordLogService
      .SaveHRApplicantRecordLogAsync(LogItem).subscribe();

      if (detType == EDetectionType.FaceDetected)
        {
          this.showDetails = false;
          this.isFaceDivVisible = false;
          if(decType == EDecisionType.HRRejected)
            {
              this.applicantDetailBehaviorCommunicationService.requestTabUpdate();
              this.answer.isFaceDetected = false;
              this.answer.isAllowedDifferentFaceAnalysis = false;
              this.updateSuspicionOfCheating.emit(LogItem)
            }
        }
      if (detType == EDetectionType.MultiFaceDetected)
        {
          this.isMultiFaceDivVisible = false;
          this.showDetails = false;
          
          if(decType == EDecisionType.HRRejected)
            {
              this.applicantDetailBehaviorCommunicationService.requestTabUpdate();
              this.answer.isMultiFaceDetected = false;
              this.answer.isAllowedMultipleFaceAnalysis = false;
              this.updateSuspicionOfCheating.emit(LogItem)
            }
        }
      if (detType == EDetectionType.UnverifiedNonFace || detType == EDetectionType.VerifiedNonFace)
        {
          this.isNonFaceDivVisible = false;
          this.showDetails = false;
          
          if(decType == EDecisionType.HRRejected)
            {
              this.applicantDetailBehaviorCommunicationService.requestTabUpdate();
              this.answer.faceDetectionStatus = EFaceDetectionStatus.VerifiedAndHasFace;
              this.answer.faceDetectionStatus = EFaceDetectionStatus.VerifiedAndHasFace;
              this.updateSuspicionOfCheating.emit(LogItem)
            }
        }
  }
}
